import { useState, useEffect } from "react";
import MainLayout from "../sidebar/Sidebar.js";
import { getFirebaseMessaging, getToken } from "../firebase";

// Web-Push VAPID Key
const VAPID_KEY =
  "BPvkS0QWxB0lgPOkqDUvXbED4IJt65jtqf4CPWxkZu_dF_XEeYN8Z1G3JNrj7zvVstXUlaRwO5J6a74xoQWaN9o";

export default function Notifications() {
  const isNotificationSupported = typeof Notification !== "undefined";
  const [permission, setPermission] = useState(
    isNotificationSupported ? Notification.permission : "default"
  );
  const [location, setLocation] = useState("Notifications");
  const [notificationsEnabled, setNotificationsEnabled] = useState(
    isNotificationSupported && Notification.permission === "granted"
  );
  const [fcmToken, setFcmToken] = useState("");

  // Watch for permission changes
  useEffect(() => {
    if (!isNotificationSupported) return;

    const interval = setInterval(() => {
      if (Notification.permission !== permission) {
        setPermission(Notification.permission);
        setNotificationsEnabled(Notification.permission === "granted");
      }
    }, 3000);

    return () => clearInterval(interval);
  }, [permission, isNotificationSupported]);

  const enableNotifications = async () => {
    if (!isNotificationSupported) {
      alert("Notifications are not supported in this browser.");
      return;
    }

    const messaging = await getFirebaseMessaging();
    if (!messaging) {
      alert("Firebase messaging is not supported in this browser.");
      return;
    }

    Notification.requestPermission().then(async (status) => {
      setPermission(status);
      setNotificationsEnabled(status === "granted");

      if (status === "granted") {
        try {
          const token = await getToken(messaging, { vapidKey: VAPID_KEY });
          if (token) {
            console.log("FCM Token:", token);
            setFcmToken(token);
          } else {
            console.warn("No FCM token available.");
            setFcmToken("");
          }
        } catch (err) {
          console.error("Error getting FCM token:", err);
          setFcmToken("");
        }
      } else {
        setFcmToken("");
      }
    });
  };

  const disableNotifications = () => {
    alert("To disable notifications, update your browser or system settings.");
    setNotificationsEnabled(false);
    setFcmToken("");
  };

  const toggleNotifications = () => {
    if (notificationsEnabled) {
      disableNotifications();
    } else {
      enableNotifications();
    }
  };

  if (!isNotificationSupported) {
    return (
      <MainLayout location={location} setLocation={setLocation}>
        <p>Your browser does not support push notifications.</p>
      </MainLayout>
    );
  }

  if (permission === "denied") {
    return (
      <MainLayout location={location} setLocation={setLocation}>
        <div>
          <p>Notifications are disabled.</p>
          <p>
            To enable them, go to your browser or OS settings and allow
            notifications.
          </p>
        </div>
      </MainLayout>
    );
  }

  return (
    <MainLayout location={location} setLocation={setLocation}>
      <div className="min-h-full py-4 px-6">
      <label
        htmlFor="notif-toggle"
        style={{
          display: "flex",
          alignItems: "center",
          gap: "0.75rem",
          cursor: "pointer",
          userSelect: "none",
        }}
      >
        <input
          type="checkbox"
          id="notif-toggle"
          checked={notificationsEnabled}
          onChange={toggleNotifications}
          style={{ width: 0, height: 0, opacity: 0, position: "absolute" }}
        />
        <span
          style={{
            width: "40px",
            height: "20px",
            background: notificationsEnabled ? "#4ade80" : "#ccc",
            borderRadius: "9999px",
            position: "relative",
            transition: "background-color 0.3s",
          }}
        >
          <span
            style={{
              content: '""',
              position: "absolute",
              top: "2px",
              left: notificationsEnabled ? "22px" : "2px",
              width: "16px",
              height: "16px",
              background: "white",
              borderRadius: "9999px",
              transition: "left 0.3s",
              boxShadow: "0 0 2px rgba(0,0,0,0.2)",
            }}
          />
        </span>
        <span>
          {notificationsEnabled ? "Notifications ON" : "Notifications OFF"}
        </span>
      </label>

      {notificationsEnabled && fcmToken && (
        <div style={{ marginTop: "1rem" }}>
          <p>FCM Token:</p>
          <textarea
            readOnly
            style={{ width: "100%", height: "6rem" }}
            value={fcmToken}
          />
        </div>
      )}
      </div>
    </MainLayout>
  );
}
